/* global mixpanel */
import formatDate from 'mixpanel/formatDate'

export function reportGrossProfitStart ({grossProfit}) {
  mixpanel.track('Report Gross Profit Start', {
    'Cost of Goods Sold': grossProfit.cogs,
    'Discounts': grossProfit.discount,
    'Refunds': grossProfit.refund,
    'Net Sales': grossProfit.net_sales,
    'Gross Profit': grossProfit.gross_profit,
    'Gross Sales': grossProfit.gross_sales
  })
}

export function reportGrossProfitChangeFilter ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Gross Profit Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportGrossProfitHoverCOGSAdj () {
  mixpanel.track('Report Gross Profit Hover COGS Adj', {
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/reports/grossProfit.js